// extracted by mini-css-extract-plugin
module.exports = {"container-card-option-onbording":"CardOptionOnboarding_container-card-option-onbording__1JOuR"};